import Header from "./Components/PrivacyPolicy/Header"
import Content from "./Components/PrivacyPolicy/Content"
import CTA from "./Components/CTA"

const PrivacyPolicy = () => {
    return (
        <div className="select-none">
            <Header></Header>
            <Content></Content>
            <CTA></CTA>
        </div>
    )
}

export default PrivacyPolicy